import { render, staticRenderFns } from "./Pin.vue?vue&type=template&id=a71f489c&scoped=true"
import script from "./Pin.vue?vue&type=script&lang=js"
export * from "./Pin.vue?vue&type=script&lang=js"
import style0 from "./Pin.vue?vue&type=style&index=0&id=a71f489c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71f489c",
  null
  
)

export default component.exports